import { createLogger } from './utils/Logger';
import * as Dalton from './services/Dalton';
import * as UI from './ui';
import User from './User';

const { VERSION } = process.env;

// eslint-disable-next-line no-console
console.log('@adultswim/auth-sdk', VERSION);

if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger('User', '#50AD55');
    User.subscribe(data => logger.log(data ? data.isVerified ? '(VERIFIED)' : '(UNVERIFIED)' : '', User, data));
}

export {
    VERSION,
    Dalton,
    UI,
    User,
};
